import Vue from 'vue'
import firebase from 'firebase'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

// TODO move this to its own file
// TODO enable only the services we need
const firebaseConfig = {
    apiKey: "AIzaSyDwwTF87A4aylSLhWZp4Lz-Iq7fZnpLnc8",
    authDomain: "dubliveaudio-dev.firebaseapp.com",
    databaseURL: "https://dubliveaudio-dev.firebaseio.com",
    projectId: "dubliveaudio-dev",
    storageBucket: "dubliveaudio-dev.appspot.com",
    messagingSenderId: "918853764501",
    appId: "1:918853764501:web:e96b3eb3ef9e257949629c"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
